export function handlePhinMessage() {
  const message = "HI, I AM PHIN, THE REAL OG OF BASE CHAIN";
  showTypingModal(message);
  logToConsole(message);
}
